export default __webpack_public_path__ + "static/media/report-dash-icon.0e31b399.svg";